import React from 'react';
import { HeroContent } from './HeroContent';
import { HeroQuotePanel } from './HeroQuotePanel';
import { TrustBar } from './TrustBar';
import { ShowerStyles } from './ShowerStyles';
import { Reviews } from './Reviews';
import { Comparison } from './Comparison';
import { DesignOptions } from './DesignOptions';
import { Quality } from './Quality';
import { Checklist } from './Checklist';
import { Process } from './Process';
import { Benefits } from './Benefits';
import { Audiences } from './Audiences';
import { RelatedServices } from './RelatedServices';
import { WhyChoose } from './WhyChoose';
import { Locations } from './Locations';
import { ShowerDoorsFAQ } from '../../components/ShowerDoorsFAQ/ShowerDoorsFAQ';
import { FinalCTA } from './FinalCTA';
import { StickyMobileCTA } from './StickyMobileCTA';
export function ShowerDoors() {
  return <main className="min-h-screen bg-white font-sans text-gray-800 pb-[76px] md:pb-0" data-id="element-1701">
      <section className="relative bg-gradient-to-b from-glass to-white pt-8 pb-10 lg:pt-10 lg:pb-12 overflow-hidden" data-id="element-1702">
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 pointer-events-none" data-id="element-1703">
          <div className="absolute -top-[20%] -right-[10%] w-[70%] h-[70%] rounded-full bg-blue-50/50 blur-3xl" data-id="element-1704" />
          <div className="absolute top-[40%] -left-[10%] w-[50%] h-[50%] rounded-full bg-glass-dark/40 blur-3xl" data-id="element-1705" />
        </div>
        <div className="container mx-auto px-4 relative z-10 max-w-7xl" data-id="element-1706">
          <div className="grid lg:grid-cols-12 gap-8 lg:gap-10 items-center" data-id="element-1707">
            <HeroContent data-id="element-1708" />
            <HeroQuotePanel data-id="element-1709" />
          </div>
        </div>
      </section>
      <TrustBar data-id="element-1710" />
      <ShowerStyles data-id="element-1711" />
      <Reviews data-id="element-1712" />
      <Comparison data-id="element-1713" />
      <DesignOptions data-id="element-1714" />
      <Quality data-id="element-1715" />
      <Checklist data-id="element-1716" />
      <Process data-id="element-1717" />
      <Benefits data-id="element-1718" />
      <Audiences data-id="element-1719" />
      <RelatedServices data-id="element-1720" />
      <WhyChoose data-id="element-1721" />
      <Locations data-id="element-1722" />
      <ShowerDoorsFAQ data-id="element-1723" />
      <FinalCTA data-id="element-1724" />
      <StickyMobileCTA data-id="element-1725" />
    </main>;
}